// src/context/LockscreenContext.jsx
import React, { createContext, useContext, useEffect, useRef, useState } from "react";
import lockscreenConfig from "../config/lockscreenConfig";

const LockscreenContext = createContext();

export const LockscreenProvider = ({ children }) => {
  const [locked, setLocked] = useState(false);
  const [tempPassword, setTempPassword] = useState(null);
  const inactivityTimer = useRef(null);

  // ✅ Al cargar, leer de sessionStorage
  useEffect(() => {
    const storedLocked = sessionStorage.getItem("locked") === "true";
    const storedPassword = sessionStorage.getItem("tempPassword");
    setLocked(storedLocked);
    if (storedPassword) setTempPassword(storedPassword);
  }, []);

  const lock = (password) => {
    setTempPassword(password);
    setLocked(true);
    sessionStorage.setItem("locked", "true");
    sessionStorage.setItem("tempPassword", password);
  };

  const unlock = (inputPassword) => {
    if (inputPassword === tempPassword) {
      setLocked(false);
      sessionStorage.setItem("locked", "false");
      resetInactivityTimer();
      return true;
    }
    return false;
  };

  const close = () => {
    setLocked(false);
    sessionStorage.setItem("locked", "false");
  };

  const resetInactivityTimer = () => {
    if (inactivityTimer.current) {
      clearTimeout(inactivityTimer.current);
    }

    inactivityTimer.current = setTimeout(() => {
      const storedPassword = sessionStorage.getItem("tempPassword");
      if (storedPassword) {
        setTempPassword(storedPassword);
        setLocked(true);
        sessionStorage.setItem("locked", "true");
      }
    }, lockscreenConfig.inactivityTimeoutMinutes * 60 * 1000); // 1 minuto (ajustable)
  };

  useEffect(() => {
    const events = ["mousemove", "keydown", "scroll", "click"];
    const reset = () => resetInactivityTimer();

    events.forEach((event) => window.addEventListener(event, reset));
    reset();

    return () => {
      events.forEach((event) => window.removeEventListener(event, reset));
      clearTimeout(inactivityTimer.current);
    };
  }, []);

  return (
    <LockscreenContext.Provider value={{ locked, lock, unlock, close }}>
      {children}
    </LockscreenContext.Provider>
  );
};

export const useLockscreen = () => useContext(LockscreenContext);